import { useNavigate } from 'react-router-dom'

export default function Landing() {
  const navigate = useNavigate()

  return (
    <div
      className="bg-white min-h-screen w-full mx-auto relative flex flex-col"
      style={{
        maxWidth: 'clamp(320px, 100vw, 420px)',
        minHeight: '100dvh'
      }}
    >
      {/* Header with Logo - no progress bar */}
      <div
        className="absolute inset-x-0 top-0 z-10"
        style={{ paddingTop: 'env(safe-area-inset-top)' }}
      >
        <div className="bg-white h-[65px] w-full border-b border-border-light relative">
          <div className="flex items-center justify-center h-full">
            <div className="w-[160px] h-10">
              <div
                className="bg-center bg-cover bg-no-repeat size-full"
                style={{ backgroundImage: `url('/images/logo.png')` }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div
        className="flex-1 flex flex-col items-center justify-center px-6"
        style={{
          paddingTop: `calc(65px + env(safe-area-inset-top))`,
          paddingBottom: 'env(safe-area-inset-bottom)'
        }}
      >
        <div className="w-full max-w-[309px] flex flex-col gap-4">
          <button
            onClick={() => navigate('/start')}
            className="btn btn-primary w-full text-fluid-md h-fluid-btn-lg rounded-2xl"
          >
            Start Assessment
          </button>

          <button
            onClick={() => navigate('/admin/login')}
            className="btn btn-secondary w-full text-fluid-md h-fluid-btn rounded-2xl"
          >
            Clinician Login
          </button>
        </div>
      </div>
    </div>
  )
}
